<template>
  <div class="qr-code">
    <div class="left">
      <div class="left-header">起点</div>
      <div class="left-content">
        <div
          class="cal-content"
          v-for="(item,index) in startPoints"
          :key="index"
          @click="chooseItem1(index)"
          @change="chooseStart(index)"
        >
          <el-checkbox class="point" :label="item.touch_point_name" v-model="checkedArr1[index]"></el-checkbox>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="middle-header">终点</div>
      <div class="middle-content">
        <div
          class="cal-content"
          v-for="(point,index) in points"
          :key="index"
          @click="chooseItem2(index)"
          @change="chooseEnd(index)"
        >
          <el-checkbox
            class="point"
            :label="point.label_name"
            v-model="checkedArr2[index]"
            :disabled="pointDisabledArr[index]"
          ></el-checkbox>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="qrdown">
        <el-select v-model="value" placeholder="请选择小程序" class="select-item">
          <el-option v-for="item in options" :key="item.id" :value="item.info"></el-option>
        </el-select>
        <img class="qr-canvas" :src="qrimg" />
        <div class="qr-download" @click.stop="downloadIamge3d">下载二维码</div>
      </div>
      <i class="el-icon-close close-icon" @click="closeQr"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "upload",
  data() {
    return {
      startPoints: [],
      checkedArr1: [!0],
      checked1: 0,
      points: [],
      checkedArr2: [!0],
      checked2: 0,
      pointDisabledArr: [!!0],
      qrimg: require(`@/assets/views/map/icon/qr.jpg`),
      index1: 0,
      index2: 0,
      options: [],
      value: ""
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      //   console.log(this.startPoints);
      this.startPoints.splice(0, 1, { touch_point_name: "自动定位起点" });
      const len = this.startPoints.length;
      for (let i = 0; i < len - 1; i++) {
        this.checkedArr1.push(!!0);
      }

      this.getPoint();
      this.getweChat();
    });
  },
  methods: {
    closeQr() {
      this.$emit("closeQr", !0);
    },
    setDisabled(index) {
      const len = this.pointDisabledArr.length;
      const bool = index > 0 ? !!0 : !0;
      for (let i = 1; i < len; i++) {
        this.pointDisabledArr[i] = bool;
      }
      bool ? this.chooseItem2(0) : null;
    },
    chooseItem1(index) {
      this.checkedArr1[this.checked1] = !!0;
      this.checked1 = index;
      this.checkedArr1[index] = !0;
      //   console.log(this.checkedArr1);
      this.setDisabled(index);
    },
    chooseStart(index) {
      if (index < 1) return;

      this.index1 = index;
      this.generate();
    },
    chooseEnd(index) {
      this.index2 = index;
      if (this.pointDisabledArr[this.index2]) return;
      this.generate();
    },
    chooseItem2(index) {
      this.checkedArr2[this.checked2] = !!0;
      this.checked2 = index;
      this.checkedArr2[index] = !0;
      //   this.index2 = index;
    },

    async getPoint() {
      //获取终点

      try {
        const { data } = await this.$http.post("/navigation/init-paintingmap", {
          store_id: this.$store.state.storeId
        });

        if (data.error_no === 200) {
          //   console.log(data.data.painting_map_info.label_data);
          this.points.push({ label_name: "无终点", end: !0 });
          const label_data = data.data.painting_map_info.label_data;
          this.points = [
            ...this.points,
            ...label_data.point.filter(v => v.label_name)
          ];
          label_data.line.forEach(v => {
            this.points.concat(v.filter(v1 => v1.label_name));
          });
          // console.log(this.points);
          const len = this.points.length;
          for (let i = 0; i < len - 1; i++) {
            this.pointDisabledArr.push(!0);
            this.checkedArr2.push(!!0);
          }
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async getweChat() {
      try {
        const { data } = await this.$http.post("/navigation/list-wechat-app", {
          store_id: this.$store.state.storeId
        });

        if (data.error_no === 200) {
          //   console.log(data.data.wechat_apps);
          this.options = data.data.wechat_apps;
          // console.log(this.opitons);
          
          this.value = this.options[0].info;
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async generate() {
      //获取终点
      //   console.log(this.startPoints[this.index1]);
      //   console.log(this.points[this.index2]);

      const id = this.value?this.options.filter(v=>v.info === this.value)[0].id:null;
      const start = this.startPoints[this.index1];
      const end = this.points[this.index2].end
        ? {
            label_name: null,
            index: null,
            label_code: null
          }
        : this.points[this.index2];
      //   console.log(end);

      try {
        const { data } = await this.$http.post("/navigation/generate-qrcode", {
          store_id: this.$store.state.storeId,
          touch_point_id: start.touch_point_id,
          wechat_id: id,
          destination_info: {
            dest_labelname: end.label_name,
            dest_label_id: end.index,
            dest_coordinate: end.label_code
          }
        });

        if (data.error_no === 200) {
          //   console.log(data);
          //   this.qrimg = require(`${data.data.qrcode_url}`);
          this.qrimg = data.data.qrcode_url;
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    downloadIamge3d() {
      const imgsrc = this.qrimg;
      //下载图片地址和图片名
      let image = new Image(200, 200);
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, 200, 200);
        let url = canvas.toDataURL("image/jpeg"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "qr"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    }
  }
};
</script>

<style lang="scss" scoped>
.qr-code {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;

  .left,
  .middle {
    flex: 1;
    order: -1;
    height: calc(100% - 40px);
    background: #000000;
    border-radius: 10px;
    margin: 20px 0px 20px 20px;

    .left-header,
    .middle-header {
      height: 40px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #ffffff;
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
    .left-content,
    .middle-content {
      height: calc(100% - 40px);
      overflow-y: scroll;
      .cal-content {
        height: 6%;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-items: center;
        .point {
          margin-left: 20px;
        }
      }
    }
  }
  .right {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .qrdown {
      width: 200px;
      height: 270px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .select-item {
        margin-bottom: 30px;
      }
      .qr-download {
        margin-top: 30px;
        width: 200px;
        height: 30px;
        border: 1px solid #08ce82;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #08ce82;
        letter-spacing: 0.56px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .qr-canvas {
        
        width: 200px;
        height: 200px;
      }
    }
    .close-icon {
      position: absolute;
      top: 17.4px;
      right: 17.4px;
      cursor: pointer;
    }
  }
}
</style>
